// extracted by mini-css-extract-plugin
export default {"powered":"style_powered__3nAOs","version":"style_version__qyBkp"};